<template>
    <div v-show="show">
        <div class="fixed z-40 inset-0" :class="overflow">
            <div class="flex items-center justify-center">
                <transition
                    enter-active-class="ease-out duration-300"
                    enter-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100"
                    leave-to-class="opacity-0">
                    <div class="fixed inset-0 transition-opacity" v-show="show">
                        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                    </div>
                </transition>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-top" :class="centerModal"></span>&#8203;

                <transition
                    enter-active-class="duration-150 ease-out"
                    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-active-class="duration-150 ease-in"
                    leave-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                    <div :class="dialogClasses"
                         role="dialog" aria-modal="true" aria-labelledby="modal-headline" v-show="show">
                        <div class="sm:rounded-md bg-white w-full">
                            <slot name="title" v-if="showTitle">
                                <div class="px-6 pt-4 flex justify-between items-center">
                                    <h3 :class="titleClass">
                                        {{ title }}
                                    </h3>
                                    <button :disabled="disableClose" v-if="showClose"
                                            class="text-gray-800 font-semibold outline-none hover:text-indigo-600 transition duration-300"
                                            @click="close" type="button">&#10005;
                                    </button>
                                </div>
                            </slot>

                            <div :class="{'overflow-y-auto scrollbar-thin sm:max-h-80vh': $slots.footer}">
                                <div :class="bodyClass">
                                    <slot></slot>
                                </div>
                            </div>

                            <div class="flex justify-between items-center mt-4" v-if="$slots.footer">
                                <slot name="footer"></slot>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SimpleModal",

    props: {
        show: {
            type: Boolean,
            required: true,
            default: false
        },
        title: {
            type: String,
            required: false,
            default: null
        },
        maxWidth: {
            type: String,
            required: false,
            default: "sm:max-w-lg"
        },
        bodyClass: {
            type: String,
            required: false,
            default: "px-6 py-4"
        },
        titleClass: {
            type: String,
            required: false,
            default: "text-lg font-medium text-gray-900",
        },
        disableClose: {
            type: Boolean,
            required: false,
            default: false,
        },
        showTitle: {
            type: Boolean,
            required: false,
            default: true,
        },
        showClose: {
            type: Boolean,
            required: false,
            default: true,
        },
        overflow: {
            type: String,
            required: false,
            default: "overflow-y-auto"
        },
        centerModal: {
            type: String,
            required: false,
            default: "sm:h-screen",
            description: "Pass a blank center-modal as a prop to have the simple modal display in the middle of the screen on top of another modal"
        },
        fixToTop: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    computed: {
        dialogClasses () {
            let classList = "items-center w-full inline-block align-bottom bg-transparent transform transition-all text-left sm:align-middle sm:w-full sm:my-16 ";

            classList += this.maxWidth;

            if (this.fixToTop) {
                classList += " fixed top-10";
            }

            return classList;
        },
    },

    methods: {
        close () {
            this.$emit("close");
        },
    }
};
</script>
